import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { PaginatedResult } from "@shared-kernel/domain/types/paginated-result";
import type { FundingListItemVM, FundingListPaginationParams } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveFundings = createAsyncThunk<
  PaginatedResult<FundingListItemVM>,
  FundingListPaginationParams,
  { extra: Partial<Dependencies> }
>("fundings/retrieveFundings", async (params: FundingListPaginationParams, { extra: { adminRepository } }) => {
  return adminRepository!.adminGetFundingList(params);
});
